import PropTypes from 'prop-types';

import ActivityHistoryItem from './ActivityHistoryItem';

const HISTORY_FILTERS = [
	{ key: 'all', label: 'Alle' },
	{ key: 'communication', label: 'Aktivitäten' },
	{ key: 'note', label: 'Notizen' },
	{ key: 'stage_change', label: 'Stage-Wechsel' },
	{ key: 'system', label: 'System' },
];

function dotClassFor(activity, isCompletedTask) {
	if (activity.activityType === 'stage_change') return 'bg-primary-100 border-primary-300 text-primary-600';
	if (isCompletedTask) return 'bg-success-200 border-success-500 text-success-500';
	return 'bg-white border-bgBase-600 text-bgBase-800';
}

function isCompletedTaskActivity(a) {
	return a.activityType === 'task' && a.status === 'completed' && a.channelPayload?.reached === null;
}

const HistorySection = ({
	history,
	historyFilter,
	setHistoryFilter,
	isLoading,
	editingActivityId,
	resolveChannel,
	resolveIcon,
	historyMenuId,
	setHistoryMenuId,
	onEdit,
	onReopen,
	onDelete,
	renderInlineEditForm,
}) => (
	<div className="space-y-2.5">
		<div className="flex items-center gap-2.5">
			<h3 className="text-sm font-semibold text-text">Verlauf</h3>
			<div className="ml-auto inline-flex bg-bgBase-300 border border-bgBase-500 rounded-card p-0.5 gap-0.5">
				{HISTORY_FILTERS.map(({ key, label }) => (
					<button
						key={key}
						type="button"
						onClick={() => setHistoryFilter(key)}
						className={`px-2.5 py-1 text-[11px] rounded-control font-medium transition-colors ${
							historyFilter === key ? 'bg-white text-text' : 'text-bgBase-800 hover:text-text'
						}`}
					>
						{label}
					</button>
				))}
			</div>
		</div>
		{isLoading ? (
			<p className="text-xs text-bgBase-800 py-4">Wird geladen …</p>
		) : history.length === 0 ? (
			<p className="text-xs text-bgBase-800 italic py-4 text-center">Kein Verlauf für diesen Filter</p>
		) : (
			<div className="relative pl-6">
				<div className="absolute left-[11px] top-2 bottom-2 w-[2px] bg-bgBase-500" />
				<div className="space-y-3">
					{history.map((a) => {
						const isCompletedTask = isCompletedTaskActivity(a);
						const isImmutable = a.activityType === 'stage_change' || a.activityType === 'system';
						const isCampaign = Boolean(a.channelPayload?.campaignId);
						const canReopen =
							!isImmutable && !isCampaign && a.status === 'completed' && a.activityType === 'task';
						return (
							<ActivityHistoryItem
								key={a.id}
								activity={a}
								channelType={resolveChannel(a)}
								Icon={resolveIcon(a)}
								dotClass={dotClassFor(a, isCompletedTask)}
								isCompletedTask={isCompletedTask}
								isImmutable={isImmutable}
								isCampaign={isCampaign}
								canReopen={canReopen}
								when={a.completedAt ?? a.createdAt}
								historyMenuId={historyMenuId}
								setHistoryMenuId={setHistoryMenuId}
								onEdit={onEdit}
								onReopen={onReopen}
								onDelete={onDelete}
								renderInlineEditForm={renderInlineEditForm}
								isEditing={editingActivityId === a.id}
							/>
						);
					})}
				</div>
			</div>
		)}
	</div>
);

HistorySection.propTypes = {
	history: PropTypes.array.isRequired,
	historyFilter: PropTypes.string.isRequired,
	setHistoryFilter: PropTypes.func.isRequired,
	isLoading: PropTypes.bool,
	editingActivityId: PropTypes.string,
	resolveChannel: PropTypes.func.isRequired,
	resolveIcon: PropTypes.func.isRequired,
	historyMenuId: PropTypes.string,
	setHistoryMenuId: PropTypes.func.isRequired,
	onEdit: PropTypes.func.isRequired,
	onReopen: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
	renderInlineEditForm: PropTypes.func.isRequired,
};

export default HistorySection;
